import { FC, useState } from 'react';

import PrimaryButton from 'components/FreeTrialFTUX/ui/PrimaryButton';
import StepShell from 'components/FreeTrialFTUX/ui/StepShell';

import type { UseCaseAnswer, UseCaseOption } from 'components/FreeTrialFTUX/config/types';

interface UseCaseStepProps {
  heading: string;
  description: string;
  question: string;
  options: UseCaseOption[];
  initialValue?: UseCaseAnswer;
  nextLabel: string;
  skipLabel: string;
  onAnswer: (answer: UseCaseAnswer) => void;
  onSkip: () => void;
  isTransitioning: boolean;
}

const UseCaseStep: FC<UseCaseStepProps> = ({
  heading,
  description,
  question,
  options,
  initialValue,
  nextLabel,
  skipLabel,
  onAnswer,
  onSkip,
  isTransitioning,
}) => {
  const [selected, setSelected] = useState<UseCaseAnswer | undefined>(initialValue);

  return (
    <StepShell
      heading={heading}
      description={description}
      stepNumber={1}
      onSkip={onSkip}
      skipLabel={skipLabel}
      isTransitioning={isTransitioning}
      rightPanel={
        <div className="flex flex-col gap-3">
          <p className="font-roboto text-sm font-semibold leading-5 text-ftux-label">{question}</p>
          <div className="flex flex-col gap-3">
            {options.map(option => {
              const isSelected = selected === option.id;

              return (
                <button
                  key={option.id}
                  type="button"
                  onClick={() => setSelected(option.id as UseCaseAnswer)}
                  className={`rounded-[30px] px-6 py-2.5 text-center font-roboto text-lg font-medium leading-7 text-gray-900 outline outline-1 transition-colors ${
                    isSelected
                      ? 'bg-primary-50 outline-primary-300'
                      : 'bg-ftux-surface outline-gray-300 hover:outline-gray-400'
                  }`}
                >
                  {option.label}
                </button>
              );
            })}
          </div>
        </div>
      }
      bottomAction={
        <PrimaryButton onClick={() => selected && onAnswer(selected as UseCaseAnswer)} disabled={!selected}>
          {nextLabel}
        </PrimaryButton>
      }
    />
  );
};

export default UseCaseStep;
